<template>
  <component :is="layout">
    <router-view></router-view>
    <Notifications/>
    <IwalyNotifications/>
  </component>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MainLayout from '@/layout/MainLayout.vue';
import LoginLayout from '@/layout/LoginLayout.vue';
import Notifications from '@/components/Notifications.vue';
import IwalyNotifications from '@/components/global/IwalyNotifications.vue';
import { ADMIN_PERMISSIONS, canAccess } from '@/access/adminAccess';

export default {
  components: {
    MainLayout,
    LoginLayout,
    Notifications,
    IwalyNotifications,
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
    }),
    layout: {
      get() {
        switch (this.$route.name) {
          case 'login':
            return LoginLayout;
          default:
            return MainLayout;
        }
      },
    },
  },
  methods: {
    ...mapActions({
      logout: 'auth/ACT_LOGOUT',
    }),
  },
  watch: {
    authenticated: {
      handler(value) {
        if (value) {
          this.$nextTick().then(() => {
            this.$store.dispatch('settings/ACT_FETCH_COUNTRIES');
            this.$store.dispatch('settings/ACT_FETCH_INDIVIDUAL_REGIONS');
            this.$store.dispatch('settings/ACT_FETCH_ORDER_TIMERS');
            this.$store.dispatch('services/ACT_FETCH_SERVICE_CATEGORIES');
            if (canAccess(this.$store.state.auth.user, ADMIN_PERMISSIONS.ORDERS)) {
              this.$store.dispatch('notifications/ACT_FETCH_NOTIFICATIONS', {});
            }
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$eventBus.$on('authenticated', () => {
      this.$router.push({
        name: 'home',
      });
    });
    this.$eventBus.$on('unauthenticated', () => {
      this.$router.push({
        name: 'login',
      }).catch(() => {});
    });
    this.$eventBus.$on('unauthorized', () => {
      this.logout();
    });
  },
  beforeDestroy() {
    this.$eventBus.$off('authenticated');
    this.$eventBus.$off('unauthenticated');
    this.$eventBus.$off('unauthorized');
  },
};
</script>
